import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Tagline = styled.div.withConfig({
  displayName: "Tagline",
  componentId: "sc-67kf8w-0"
})(["margin-top:", ";", ";font-weight:400;color:", ";"], function (_ref) {
  var extraMargin = _ref.extraMargin;
  return extraMargin ? '9px' : '6px';
}, getFont(-1, 'compact'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fontL;
});